export default "__VITE_ASSET__CR95dCCy__"